( function( $ ) {
  function autoHeightCourseTitle() {
    /* Make the title height adjustable */
    if( $( window ).width() >= 624 ) {
      var heights = $( '#layout[data-activelayout="grid"] .__course' ).map( function( i, el ) {
        return $( 'h4', el ).height();
      } ).get();
    
      $( '#layout[data-activelayout="grid"] .__course h4' ).height( Math.max.apply( Math, heights ) );
    } else {
      $( '#layout[data-activelayout="grid"] .__course h4' ).height( 'auto' );
    }

    $( window ).resize( function () {
      if( $( window ).width() >= 624 ) {
        heights = $( '#layout[data-activelayout="grid"] .__course' ).map( function( i, el ) {
          return $( 'h4', el ).height();
        } ).get();
      
        $( '#layout[data-activelayout="grid"] .__course h4' ).height( Math.max.apply( Math, heights ) );
      } else {
        $( '#layout[data-activelayout="grid"] .__course h4' ).height( 'auto' );
      }
    } );
  }
  autoHeightCourseTitle();

  function setDefaultLayout() {
    /* Chnage default layout in mobile devices */
    if( $( window ).width() <= 1023 ) {
      $( '#layout' ).attr( 'data-activelayout', 'list' );
    } else {
      /* Set the active layout before compression */
      $( '#layout' ).attr( 'data-activelayout', $( '.__layout a.__layout_active' ).data( 'layout' ) );
    }

    $( window ).resize( function () {
      /* Change default layout in mobile devices */
      if( $( window ).width() <= 1006 ) {
        $( '#layout' ).attr( 'data-activelayout', 'list' );
      } else {
        /* Set the active layout before compression */
        $( '#layout' ).attr( 'data-activelayout', $( '.__layout a.__layout_active' ).data( 'layout' ) );
      }
    } );
  }
  setDefaultLayout();

  /* Change layout */
  $( document ).on( 'click', '.__layout a', function( e ) {
    e.preventDefault();

    if( ! $( this ).hasClass( '__layout_active' ) ) {
      var layout = $( this ).data( 'layout' );
      
      /* Remove Active Layout */
      $( '.__layout a' ).removeClass( '__layout_active' );
      $( this ).addClass( '__layout_active' );

      $( '#layout' ).attr( 'data-activelayout', layout );
    }
  } );
} ) ( jQuery );